<template lang="html">
  <div id="d-profile-page">

    <section class="short-info-section-s1">
      <div class="box-top">
        <div class="col-12 col-title">
          <h2 class="txt-breadcrumb">
            <span>Mi perfil</span>
            Mi contraseña
          </h2>
        </div>
      </div>
    </section>

    <section class="main-section">
      <b-form class="form" @submit="onSubmit">
        <div class="row">

          <div class="col-lg-6">
            <b-form-group class="form-group-s1"
              label="Contraseña actual">
              <div class="eye-box">
                <b-form-input
                  id="il-1"
                  v-model="form.password"
                  type="password"
                  placeholder="••••••••"
                  required
                ></b-form-input>
                <i class="fas icon-eye" v-bind:class="{ 'fa-eye' : showpassOne, 'fa-eye-slash' : !showpassOne }"  @click="showpassOne = !showpassOne"></i>
              </div>
            </b-form-group>
          </div>

          <div class="col-lg-6"></div>

          <div class="col-lg-6">
            <b-form-group class="form-group-s1"
              label="Nueva contraseña">
              <div class="eye-box">
                <b-form-input
                  id="il-2"
                  v-model="form.newPassword"
                  type="password"
                  placeholder="••••••••"
                  required
                ></b-form-input>
                <i class="fas icon-eye" v-bind:class="{ 'fa-eye' : showpassTwo, 'fa-eye-slash' : !showpassTwo }"  @click="showpassTwo = !showpassTwo"></i>
              </div>
            </b-form-group>
          </div>

          <div class="col-lg-6">
            <b-form-group class="form-group-s1"
              label="Confirmar contraseña">
              <div class="eye-box">
                <b-form-input
                  id="il-3"
                  v-model="form.coPassword"
                  type="password"
                  placeholder="••••••••"
                  required
                ></b-form-input>
                <i class="fas icon-eye" v-bind:class="{ 'fa-eye' : showpassThree, 'fa-eye-slash' : !showpassThree }"  @click="showpassThree = !showpassThree"></i>
              </div>
            </b-form-group>
          </div>

          <div class="col-12 mt-1 mt-lg-4 text-center">
            <b-button type="submit" class="btn-s1 bg-red btn-lg btn-send">Cambiar contraseña</b-button>
          </div>
          
        </div>
      </b-form>
      <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">
        <div class="fa-3x" v-if="modal.icon== ''"><i class="fas fa-spinner fa-pulse"></i></div><br/>
        <div v-html="modal.msg"></div>
        
      </sweet-modal>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      showpassOne: false,
      showpassTwo: false,
      showpassThree: false,

      form: {
        password: null,
        newPassword: null,
        coPassword: null,
      },
      modal:{
        msg:'',
        icon:'',
        block:false,
      },
    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
      if(this.form.newPassword !== this.form.coPassword){
            
            this.modal.block = false;
            this.modal.icon = 'error';
            this.modal.msg = 'Las contrseñas no coiciden';
            this.$refs.modal.open();
            return;
        }

        this.modal.icon = "";
        this.modal.msg = 'Cargando...';
        this.modal.block = true;
        this.$refs.modal.open();

        axios.post(tools.url('/api/user/password'), this.form).then((response)=>{
            
                this.modal.block = false;
                this.modal.icon = "success";
                this.modal.msg = response.data.msg;
                
        }).catch((error)=>{
            this.modal.block = false;
            this.modal.icon = "error";
            this.modal.msg = error.response.data;

        });
    },
  },

  watch:{
    'showpassOne':function (val) {
      if (val == true) {
        $("#il-1").prop('type','text');
      } else {
        $("#il-1").prop('type','password');
      }
    },
    'showpassTwo':function (val) {
      if (val == true) {
        $("#il-2").prop('type','text');
      }
      else if (val == false) {
        $("#il-2").prop('type','password');
      }
    },
    'showpassThree':function (val) {
      if (val == true) {
        $("#il-3").prop('type','text');
      }
      else if (val == false) {
        $("#il-3").prop('type','password');
      }
    },
  },
}
</script>
